import React from 'react'
import { Spin } from 'antd'
import { useSelector } from 'react-redux'
import CommonTable from '../../components/CommonTable'
import TrackerNote from '../../components/TrackerNote'

const ServiceDetails = () => {
  const { services, isLoading } = useSelector((state) => state.services)

  const columns = [
    {
      title: 'Service Name',
      dataIndex: 'serviceName',
      key: 'serviceName',
    },
    {
      title: 'Service Server',
      dataIndex: 'serviceServer',
      key: 'serviceServer',
    },
    {
      title: 'Path',
      dataIndex: 'path',
      key: 'path',
      ellipsis: true,
    },
    {
      title: 'Timing',
      dataIndex: 'timing',
      key: 'timing',
    },
    {
      title: 'Service Type',
      dataIndex: 'serviceType',
      key: 'serviceType',
    },
    {
      title: 'Port',
      dataIndex: 'port',
      key: 'port',
      width: 80,
    },
    {
      title: 'Protocol',
      dataIndex: 'protocol',
      key: 'protocol',
      width: 100,
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      width: 100,
    },
  ]

  const note = (
    <TrackerNote
      text="To update service detail please update tracker -"
      linkLabel="Service List - All Items"
      href="https://eur01.safelinks.protection.outlook.com/?url=https%3A%2F%2Fsites.ey.com%2Fsites%2Finapps%2FLists%2FService%2520List%2FAllItems.aspx&data=05%7C02%7CKallol.Roy%40bd.ey.com%7Cc003e2851a714266789008df196804a7%7C5b973f9977df4bebb27daa0c70b8482c%7C0%7C0%7C639257606674055101%7CUnknown%7CTWFpbGZsb3d8eyJFbXB0eU1hcGkiOnRydWUsIlYiOiIwLjAuMDAwMCIsIlAiOiJXaW4zMiIsIkFOIjoiTWFpbCIsIldUIjoyfQ%3D%3D%7C0%7C%7C%7C&sdata=iAohI%2BRwVlgn1NnEAdWDpz6FAyCWJXbsWvPGLQgoI3Y%3D&reserved=0"
    />
  )

  if (isLoading) {
    return <Spin size="large" />
  }

  if (!services || services.length === 0) {
    return (
      <>
        {note}
        <div style={{ textAlign: 'center', padding: '40px', color: '#999' }}>No data available</div>
      </>
    )
  }

  return (
    <>
      {note}
      <CommonTable
        columns={columns}
        dataSource={services}
        rowKey="serviceId"
      />
    </>
  )
}

export default ServiceDetails
